<template>
  <div>

  <Drawer :mask-closable="true" @on-close="reset()" class="demo-drawer-prime"
          title="Add Gallery Image" v-model="$parent.galleryFormDrawer" width="600">

    <Form :model="galleryForm" :rules="ruleGalleryForm" label-position="top" ref="galleryForm">
      <Row :gutter="10">
        <Col span="24" style="cursor: pointer" v-if="!galleryForm.imageUrl">
          <div class="image-box" @click="uploadFileDialog=true">
            <div><i class="fas fa-cloud-upload-alt"></i> Upload Image</div>
          </div>
        </Col>
        <Col span="24" v-else>
          <div class="selected-image" @click="uploadFileDialog=true">
          <img :src="galleryForm.imageUrl" class="w-100" height="200">
          </div>
        </Col>

        <Col span="24">
          <FormItem prop="redirectUrl" label="Redirect Url">
            <Input v-model="galleryForm.redirectUrl" />
          </FormItem>
        </Col>
        <Col span="24">
          <FormItem prop="caption" label="Caption">
            <Input v-model="galleryForm.caption" />
          </FormItem>
        </Col>
        <Col span="24">
          <FormItem prop="isActive" label="">
            <Checkbox v-model="galleryForm.isActive"> &nbsp;isActive</Checkbox>
          </FormItem>
        </Col>


        <Col span="24" style="text-align: right">
          <Button v-show="!editMode" @click="addGalleryImage" type="primary" :loading="loading">
            <span v-if="!loading">Add Image</span>
            <span v-else>Loading...</span>
          </Button>
          <Button v-show="editMode" @click="modifyGalleryImage" type="primary">Update</Button>
        </Col>

      </Row>
    </Form>
  </Drawer>

<upload-file @closeUploadFileDialog="uploadFileDialog=false" :uploadFileDialog="uploadFileDialog"
             @fileResponseData="onReceiveFileResponse($event)"></upload-file>
  </div>
</template>

<script>
  import {generateUUID} from "../Constants/Constant";
  import moment from 'moment'
  import {ADD_GALLERY_IMAGE, UPDATE_GALLERY_IMAGE} from "../graphql/mutations/gallery";
  import UploadFile from "./UploadFile";
  export default {
    name: "GalleryForm",
    props: ['galleryImages'],
    components: {UploadFile},
    data: function(){
      return {
        moment: moment,
        galleryForm:{
          id: '',
          imageUrl: '',
          redirectUrl : '',
          caption : '',
          sequenceNo : '',
          isActive : false,
        },
        ruleGalleryForm: {},
        uploadFileDialog: false,
        editMode: false,
        loading: false
      }
    },
    methods: {
      reset: function(){
        this.$refs['galleryForm'].resetFields();
        this.galleryForm.imageUrl = '';
      },
      onReceiveFileResponse (fileResponse) {
        this.uploadFileDialog = false
        this.galleryForm.imageUrl = fileResponse.url
      },
      setGalleryForm(galleryData){
        this.galleryForm.id = galleryData.id;
        this.galleryForm.imageUrl = galleryData.imageUrl;
        this.galleryForm.redirectUrl = galleryData.redirectUrl;
        this.galleryForm.caption = galleryData.caption;
        this.galleryForm.sequenceNo = galleryData.sequenceNo;
        this.galleryForm.isActive = galleryData.isActive;
        this.editMode = true;
      },
      addGalleryImage(){
        this.loading = true
        this.$refs['galleryForm'].validate((valid) => {
          if (valid && this.galleryForm.imageUrl) {
            this.insertGalleryImage();
          }else if(!this.galleryForm.imageUrl){
            this.$Message.success('Please select Image');
            this.loading = false
          }else{
            this.$Message.success('Please check details');
            this.loading = false
          }
        })
      },
      async insertGalleryImage(){

        let response = await this.$apollo.mutate({
          mutation: ADD_GALLERY_IMAGE,
          variables: {
            object: {
              ...this.galleryForm,
              ...{
                id: generateUUID(),
                sequenceNo: this.galleryImages.length,
                created_at: moment().format(),
                updated_at: moment().format()
              }
            }
          }
        })
        if(response.data.insert_gallery.returning[0].id){
          this.$Message.success('Gallery image added successfully!');
          this.reset();
          this.loading = false
          this.$parent.galleryFormDrawer = false;
        }
      },
      modifyGalleryImage(){
        this.$refs['galleryForm'].validate((valid) => {
          if (valid && this.galleryForm.imageUrl) {
            this.updateGalleryImage();
          }else if(!this.galleryForm.imageUrl){
            this.$Message.success('Please select Image');
            this.loading = false
          }else{
            this.$Message.success('Please check details');
            this.loading = false
          }
        })
      },
      async updateGalleryImage(){
        let response = await this.$apollo.mutate({
          mutation: UPDATE_GALLERY_IMAGE,
          variables: {
            id: this.galleryForm.id,
            object: {
              ...this.galleryForm,
              ...{
                updated_at: moment().format()
              }
            }
          }
        })
        if(response.data){
          this.$Message.success('Gallery Image updated successfully!');
          this.reset();
          this.$parent.galleryFormDrawer = false;
        }
      }
    }
  }
</script>

<style scoped>
.image-box{
  height: 200px;
  background: #f2f2f2;
  text-align: center;
  line-height: 200px;
  font-size: 16px;
  color: grey;
  margin: 0px auto 30px auto;
  /*width: 100%;*/
}
  .selected-image{
    margin: 0px auto 30px auto;
    cursor: pointer;
    /*width: 100%;*/
  }
</style>
